import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams,ActionSheetController ,LoadingController} from 'ionic-angular';
import { CommonProvider } from '../../providers/common/common';
import { GenericFormValidationProvider } from '../../providers/common/form-validation';
/**
 * Generated class for the ForseclousrestatementsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-statementsofaccounts',
  templateUrl: 'statementsofaccounts.html',
})
export class StatementsofaccountsPage {
arrReason:any=[];
  errorDisplay:any={};
  listCategotyComplains:any=[];
  listSubCategotyComplains:any=[];
  category:any="";
  subcomplain:any="";
  ccs_remarks:any="";
  reason:any=""
  constructor(
    private loadingCtrl:LoadingController,
    public actionSheetCtrl: ActionSheetController,private fv:GenericFormValidationProvider, public navCtrl: NavController, public navParams: NavParams,private cp:CommonProvider) {
  }
  presentActionSheet(msg) {
      const actionSheet = this.actionSheetCtrl.create({
        title: msg,
        cssClass: 'commanSheet',
        buttons: [
          {
            text: "OK",
            role: 'Ok',
            handler: () => {
               actionSheet.dismiss();
            }
          }
        ]
      });
      actionSheet.present();
    }
  ionViewDidLoad() {
    ////console.log('ionViewDidLoad ForseclousrestatementsPage');
    this.getForeclousreCategoryDetails();
  }

  getForeclousreCategoryDetails(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();
    this.cp.getForClousreCategory(loading).then((res:any)=>{
      var res=JSON.parse(res)
      loading.dismiss();
      this.arrReason = res.Payload.ibhfl_reasonsforretentiondocumentrequirements;
      // ////console.log(res.Payload.ibhfl_reasonsforretentiondocumentrequirements);
    })
  }
  postFormForValidation(){
    this.errorDisplay = this.fv.checkValidationFormAllControls(document.forms[0],true,[]);
     
    if(this.errorDisplay.valid){
     return false;
   }else{
    var ccs_casecategory="CC03";;
    var ccs_casetype="CT22";
    var ibhfl_loanaccountnumber1=localStorage.getItem('cc');
    var ccs_originatingsource="S01"
    var ccs_casesubtype = "ST200";
    var ccs_remarks = this.ccs_remarks;

    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    this.cp.postRetforclosure(loading,
                            ccs_casecategory,
                            ccs_remarks,
                            JSON.parse(localStorage.getItem("existingLoan"))[0].customercode,
                            ccs_casetype,
                            ibhfl_loanaccountnumber1,
                            ccs_originatingsource,
                            ccs_casesubtype,"RR02","SOA").then((res:any)=>{
                            loading.dismiss();
                            var res=JSON.parse(res)
                            if(res.Payload)
                            {
                              this.presentActionSheet("Your SR No. "+res.Payload.caseid+" has been resolved.")
                            }
                            else
                            {
                              this.presentActionSheet(res.Error.ErrorMessage)
                            }
                           })
   
   }
   }
}



// WEBPACK FOOTER //
// ./src/pages/statementsofaccounts/statementsofaccounts.ts